import { Button, Grid, Tooltip } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Search } from "@material-ui/icons";
import GlobitsTextField from "app/common/form/GlobitsTextField";

const SearchReviewFeedback = ({isOpenFillter}) => {
  return (
    <>
      <Grid container spacing={1} className="cards-body" style={{display:"flex", justifyContent:"flex-end"}}>
            <Grid item xs={12} sm={6} md={6}>
                <GlobitsTextField
                    label="Tìm kiếm"
                    name="keyword"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={"auto"} className="flex flex-end gap-2">
            <Button className="btn-primary" type="submit">
                <Search />
                Tìm kiếm
            </Button>
            </Grid>
        </Grid>
    </>
  );
};

export default memo(observer(SearchReviewFeedback));
